<template>
  <div>
    <div class="content">
      <img
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/4f18c03332ae7ef70702ca399c50386e.png"
      />
      <img
        class="btn"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/1d711b82cc172742217862e51ccc8cae.jpg"
        @click="bindClick"
        alt=""
      />
    </div>
    <van-overlay :show="showOverlay" z-index="3">
      <div class="wrapper" @click.stop>
        <QuestinInfo
          v-if="showOverlay"
          @cancel="bindCancel"
          @submit="bindSubmit"
        />
      </div>
    </van-overlay>
    <div class="loading" v-if="loading">
      <div class="tips">正在查询支付结果</div>
      <AppLoading></AppLoading>
    </div>
  </div>
</template>
<script>
;(function (r, d, s) {
  r._tt_config = true
  var _baq = (r._baq = r._baq || [])
  _baq.methods = ['track', 'off', 'on']
  _baq.factory = function (method) {
    return function () {
      var args = Array.prototype.slice.call(arguments)
      args.unshift(method)
      _baq.push(args)
      return _baq
    }
  }
  for (var i = 0; i < _baq.methods.length; i++) {
    var key = _baq.methods[i]
    _baq[key] = _baq.factory(key)
  }
  _baq.load = function () {
    var js,
      fjs = d.getElementsByTagName(s)[0]
    js = d.createElement(s)
    js.src = 'https://analytics.oceanengine.com/api/v2/js/sdk'
    fjs.parentNode.insertBefore(js, fjs)
  }
  _baq.load()
  if (_baq.invoked) {
    return
  }
  _baq.invoked = true
  _baq.track('pageview')
})(window, document, 'script')

import QuestinInfo from './components/question-info-shop.vue'
import AppLoading from '@/components/app/loading/loading.vue'
import { shopBaseUrl } from './data.js'
export default {
  components: {
    QuestinInfo,
    AppLoading
  },
  data() {
    return {
      showOverlay: false,
      loading: false,
      isClickedBtn: false, //按钮是否被点击过
      isLogin: false,
      isBuy: false, //是否购买商品
      payment: '', //支付渠道
      submiting: false,
      orderId: '',
      goodsId: '442', //"471",
      assetsData: {
        0: '1776802235996167', //默认
        1: '1750073080701003',
        2: '1753350849583115',
        3: '1753419390187652',
        4: '1757776675783684'
      }
    }
  },
  created() {
    this.goodsId = this.$http.curEv() == 'pro' ? '442' : '478'
    this.init()
  },
  mounted() {},
  methods: {
    init() {
      if (this.$http._getCookie('shopToken')) {
        this.isLogin = true
        this.orderId = sessionStorage.getItem('shopOrderId')
        if (this.orderId) {
          this.addEventPay()
        } else {
          this.payGoods()
        }
      }
    },
    bindClick() {
      if (!this.isLogin) {
        this.isClickedBtn = true
        this.showOverlay = true
      } else if (this.isBuy) {
        this.$router.push('/dy-add-customer-shop')
      } else if (this.payment) {
        this.addEventPay()
        location.href = this.payment
      } else {
        this.$toast('异常错误，请退出重试')
      }
    },
    bindCancel() {
      this.showOverlay = false
    },
    bindSubmit(questionData) {
      if (this.submiting) {
        return
      }
      this.submiting = true
      let params = {
        username: questionData.phone,
        check_type: 'mobile',
        auto_register: '1',
        auth_type: 'local',
        vcode: questionData.code,
        company_id: '1',
        trustlogin_tag: 'weixin',
        version_tag: 'touch'
      }
      this.$http
        .commonPost(shopBaseUrl + '/api/h5app/wxapp/new_login', params)
        .then((res) => {
          res = res.data
          if (!res.data.status_code) {
            this.$http._setCookie('shopToken', 'Bearer ' + res.data.token)
            this.payGoods(true)
          } else {
            this.$toast(res.data.message)
          }
        })
        .catch(() => {
          this.$toast('异常错误')
        })
        .finally(() => {
          this.submiting = false
        })
    },
    //支付商品
    payGoods(jumpPay) {
      let params = {
        item_id: this.goodsId, //商品id
        pay_type: 'paycentercmbalipayh5', //支付方式
        is_virtual_shop: 1, //是否虚拟订单
        order_type: 'normal',
        headerObj: {
          Authorization: this.$http._getCookie('shopToken')
        }
      }
      this.$http
        .commonGet(shopBaseUrl + '/api/h5app/wxapp/orders/clickpay', params)
        .then((res) => {
          res = res.data
          if (Array.isArray(res.data)) {
            /* 存在订单 */
            if (res.data.length) {
              this.checkOrderStatus(res.data[0].order_id, jumpPay)
            }
          } else if (!res.data.status_code) {
            this.payment = res.data.payment
            this.orderId = res.data.order_id
            sessionStorage.setItem('shopOrderId', this.orderId)
            if (res.data.payment && jumpPay) {
              this.bindCancel()
              this.addEventPay()
              location.href = res.data.payment
            }
          } else {
            this.$toast(res.data.message)
          }
        })
        .catch(() => {
          this.$toast('异常错误')
        })
    },
    /* 查询订单状态 */
    checkOrderStatus(orderId, jumpPay) {
      let params = {
        headerObj: {
          Authorization: this.$http._getCookie('shopToken')
        }
      }
      this.$http
        .commonGet(shopBaseUrl + '/api/h5app/wxapp/order/' + orderId, params)
        .then((res) => {
          res = res.data
          if (!res.data.status_code) {
            if (
              ['PAYED', 'DONE', 'WAIT_BUYER_CONFIRM'].includes(
                res.data.orderInfo.order_status
              )
            ) {
              sessionStorage.setItem('shopOrderId', '')
              this.isBuy = true
              if (jumpPay) {
                this.$toast('支付成功')
                _baq.track('form', {
                  assets_id: this.assetsData[+this.$route.query.from || 0]
                })
                setTimeout(() => {
                  this.$router.push('/dy-add-customer-shop')
                }, 1000)
              } else {
                this.$dialog
                  .confirm({
                    title: '提示',
                    message: '你已购买，是否前往添加客服'
                  })
                  .then(() => {
                    this.$router.push('/dy-add-customer-shop')
                  })
                  .catch(() => {
                    // on cancel
                  })
              }
            }
          } else {
            this.$toast(res.data.message)
          }
        })
        .catch(() => {
          this.$toast('异常错误')
        })
    },
    addEventPay() {
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.loading = true
      this.timer = setInterval(() => {
        if (!this.isBuy) {
          this.checkOrderStatus(this.orderId, true)
        } else {
          this.loading = false
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  padding-bottom: 57px;

  img {
    width: 100%;
    height: auto;
  }

  .btn {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 2;
  }
}

.wrapper {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.loading {
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 4px;
  padding: 10px;
  .tips {
    color: #fff;
    margin-bottom: 16px;
  }
  text-align: center;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
